module.exports = __webpack_public_path__ + "img/header-logo-zh.2db4ebe4.png";